export const getReminders = ({ reminder }) => reminder;
export const getRemoteReminderDialogVisibilityStatus = (state) =>
  getReminders(state).showRemoteReminderDialog;
